import { HttpMethod, PagingQuery } from "~/extensions/api";
export class FindAdminInformationCommand extends PagingQuery {
    constructor(model) {
        super(HttpMethod.Post, "information/admin/find");
        this.publishStatus = model.status?.value ?? null;
        this.target = model.target?.value ?? null;
        this.targetName = model.targetName;
        this.subject = model.subject;
    }
    publishStatus = null;
    target = null;
    targetName = "";
    subject = "";
}
